/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InsurancePeriod } from './insurancePeriod';
import { PreviousPrivateLiabilityInsurance } from './previousPrivateLiabilityInsurance';

/**
 * Represents a general liability insurance.   (german: Haftpflicht Versicherung)
 */
export interface PreviousPrivateLiabilityProduct {
  /**
   * Technical discriminator for the concrete product type.
   */
  productType: string;
  insurancePeriod?: InsurancePeriod;
  /**
   * Elementary products. Lowest level in product hierarchy.  Smallest unit for price calculation, e.g. \"PHV\", \"PLUS\"   (bipro-produktmodell::Elementarprodukt)
   */
  elementaryProducts?: Array<PreviousPrivateLiabilityInsurance>;
}
